import React from 'react'
import IframeSection from '../../sections/IframeSection'
import { ScriptSliceProps } from './types'

const ScriptSlice: React.FC<ScriptSliceProps> = ({ slice }) => {
  const { primary, items = [] } = slice
  const { s_title, s_description, s_is_main_heading, s_id_green_heading, s_script_url } = primary || {}

  const script = s_script_url?.url
    ? items.reduce(
        (script, attribute) =>
          attribute?.s_script_attribute_key
            ? { ...script, [attribute.s_script_attribute_key]: attribute.s_script_attribute_value }
            : script,
        {
          src: s_script_url?.url
        }
      )
    : undefined

  return (
    <IframeSection
      heading={s_title?.text}
      isHeadingGreen={s_id_green_heading}
      isMainHeading={s_is_main_heading}
      headingPadding={['45px', '', '85px']}
      description={s_description?.html}
      inner="inners.primary"
      paddingTop={['40px', '', '84px']}
      paddingBottom={['40px', '', '80px']}
      data={{ script }}
    />
  )
}

export default ScriptSlice
